<template>
  <div class="live-chat-wrapper no-print">
    <div class="chat-button is-flex is-pulled-left">
      <a class="live-chat-button button has-text-weight-bold is-uppercase"
         tabindex="0"
         @keypress.enter.space="toggle"
         @click="toggle"
         qa="live-chat">
        <div class="status-circle-container pr-2">
          <div v-if="appearOnline" class="pulse-circle"></div>
          <i v-if="!appearOnline" class="fal fa-circle"></i>
        </div>
        <span v-if="!isMobile">LIVE CHAT</span>
        <span v-if="isMobile"><i class="fal fa-comments is-size-6"></i></span>
      </a>
    </div>
  </div>
</template>
<script>

import breakpoints from '@/libs/breakpoints'
import ToggleSwitch from '@/components/Controls/ToggleSwitch'
import state from '../state'
import componentState from '@/mixins/component-state'
import auth from '@/mixins/auth'

export default {
  components: {
    ToggleSwitch
  },
  mixins: [componentState, auth],
  props: {
    liveChat: {
      type: String,
      required: true
    },
    toggle: {
      type: Function,
      required: true
    },
    status: {
      type: Boolean
    },
    role: {
      type: String
    }
  },
  data: function () {
    return {
      appearOnline: null
    }
  },
  mounted: function () {
    this.appearOnline = this._get(state.project.isOnline)
  },
  computed: {
    isMobile: function () {
      return breakpoints.isMobile()
    },
    projectIsOnline: function () {
      return this.appearOnline
    },
    canToggleStatus: function () {
      return this.role === 'owner' || this.role === 'co-owner' || this.isAdmin
    }
  },
  watch: {
    status: function (value) {
      this.appearOnline = value
    }
  }
}
</script>
<style lang="scss" scoped>
  @import '~styles/utils.scss';
  .online-toggle {
    position: absolute;
    top: 70px;
    min-width: max-content;
    label {
      margin-left: 0.55rem;
      font-size: .65rem;
      color: #373737;
    }
    @include mobile {
      display: none;
    }
  }
  .live-chat-wrapper {
    padding: 2rem 0 0 0.75rem;
    /*z-index: 1;*/
    @include mobile {
      padding:  2.1rem 0 0.75rem 0.75rem;
      display: flex;
      flex-direction: row;
    }
  }
  .chat-button {
    -webkit-box-align: center;
    -ms-flex-align: center;
    align-items: center;
    -webkit-box-pack: center;
    -ms-flex-pack: center;
    justify-content: center;
    color: #373737;
    letter-spacing: .05rem;
    a {
      width: 130px;
      font-size: 0.65rem;
      border-radius: 0;
      @include mobile {
        width: 70px;
      }
    }
  }
  .live-chat-button {
    border: 1px solid #A1A1A1;
    color: #373737;
  }
  .pulse-circle {
    color: #06b115;
    background-color: #06b115;
    -webkit-animation: pulse 2s;
    -webkit-animation-iteration-count: infinite;
    border-radius: 50%;
    height: 10px;
    width: 10px;
    @include mobile {
      left: 15px;
    }
  }
  @keyframes pulse {
    0% {
      transform: scale(0.95);
      box-shadow: 0 0 0 0 rgba(6, 177, 21, 0.7);
    }
    70% {
      transform: scale(1);
      box-shadow: 0 0 0 7px rgba(6, 177, 21, 0);
    }
    100% {
      transform: scale(0.95);
      box-shadow: 0 0 0 0 rgba(6, 177, 21, 0);
    }
  }
</style>
